<template>
	<div style="height:100%;" align="Center" v-if="$store.getters.isInternalUser">
		<div id="overall-body">
			<!-- body start -->
			<div id="body-container" align="left">
				<table id="body-table" cellspacing="0" cellpadding="0">
					<tbody>
						<tr>
							<!-- MainBody Starts -->
							<td id="main-container">
								<!-- Main Content Starts -->
									<table width="100%" cellspacing="5" cellpadding="0" border="0">
										<tbody>
											<tr valign="top">
												<td valign="top" align="left">
													<div class="full-width">
														<div style="border: 1px solid black; margin: 0 2rem; text-align: right;">
															<span style="font-size: 10px;">
																Unit J, Building 2, 3 Ceres Court PO Box 303484, North Harbour, Auckland<br>
																Tel. 09 4772720 Email <a href="mailto:keithf@compassnzl.co.nz">keithf@compassnzl.co.nz</a>
															</span><br><br>
															<div style="text-transform: uppercase; font-weight: bold; font-size: 18px; letter-spacing: 1px; text-align: center;">
																Report In Lieu Of Form 12A
															</div>
														</div>
														<div style="border: 1px solid black; margin: 0 2rem;">
															<table width="100%" cellspacing="0" cellpadding="0">
																<tbody>
																	<tr>
																		<td colspan="2" class="title">The Building</td>
																	</tr>
																	<tr class="btm-border">
																		<td><strong>Street address:</strong></td>
																		<td>{{propertyData.streetAddress}} {{propertyData.suburb}} {{propertyData.city}}</td>
																	</tr>
																	<tr class="btm-border">
																		<td><strong>Legal Description of land where building is located:</strong></td>
																		<td>{{bwof.legalDescription}}</td>
																	</tr>
																	<tr class="btm-border">
																		<td><strong>Building name / trading name:</strong></td>
																		<td>{{propertyData.buildingName}}</td>
																	</tr>
																	<tr class="btm-border">
																		<td><strong>Location of Building within site/block number:</strong></td>
																		<td>{{bwof.locationOfBuildingWithinSite}}</td>
																	</tr>
																	<tr>
																		<td style="padding-left: 10px;"><strong>Level/Unit Number:</strong><span>{{bwof.levelUnitNo}}</span></td>
																		<td> <div style="width: 345px; text-align: right;"><strong>CS #:</strong> <span>{{bwof.complianceSchedule}}</span></div></td>
																	</tr>
																</tbody>
															</table>
														</div>
														<div style="border: 1px solid black; margin: 0 2rem;">
															<table width="100%" cellspacing="0" cellpadding="0">
																<tbody>
																	<tr>
																		<td colspan="2" class="title">The Owner</td>
																	</tr>
																	<tr class="btm-border">
																		<td><strong>Name of Owner:</strong></td>
																		<td>{{owner.companyName}}</td>
																	</tr>
																	<tr class="btm-border">
																		<td><strong>Contact Person:</strong></td>
																		<td>{{ownerContact.firstName}} {{ownerContact.lastName}}</td>
																	</tr>
																	<tr class="btm-border">
																		<td><strong>Mailing Address:</strong></td>
																		<td>{{owner.postalAddress}} {{owner.suburb}} {{owner.city}}</td>
																	</tr>
																	<tr>
																		<td style="padding-left: 10px;"><strong>Street address / registered office:</strong><span>{{owner.streetAddress}}</span></td>
																		<td>&nbsp;</td>
																	</tr>
																</tbody>
															</table>
														</div>
														<div style="border: 1px solid black; margin: 0 2rem; min-height: 150px;">
															<div class="title">
																Specified System Or Feature
															</div>
															<table width="100%" cellspacing="0" cellpadding="0">
																<tbody>
																	<!--for each specified system or feature-->
																	<template v-for="srv in visibleServices" v-bind:key="srv.serviceId">
																		<tr class="btm-border"><td><span>{{srv.ref}}</span></td><td>{{srv.serviceName}}</td></tr>
																	</template>
																</tbody>
															</table>
														</div>
														<div style="border: 1px solid black; margin: 0 2rem;">
															<div class="title">
																Report
															</div>
															<table width="100%" cellspacing="0" cellpadding="0">
																<tbody>
																	<tr>
																		<td colspan="2" style="font-style: italic; padding: 0 10px;">
																			1) A
																			full explanation of why the required inspection, maintenance or
																			reporting procedures have not been carried out for the 12 months prior
																			to the anniversary date of the Compliance Schedule and what corrective
																			action has been undertaken to eliminate any reoccurrence.
																		</td>
																	</tr>
																	<tr class="btm-border">
																		<td colspan="2">
																			<div contenteditable="true" class="editable-div">
																				Owners inspections allocated to
																				tenant to complete however this was not done despite record book being
																				available on site. This has been discussed with tenant and an assurance
																				has been provided that these will be completed in accordance with the
																				Compliance Schedule ongoing.
																			</div>
																		</td>
																	</tr>
																	<tr>
																		<td colspan="2" style="font-style: italic; padding: 0 10px;">
																			2) A
																			statement that any remedial work and/or inspection and maintenance on
																			the specified system/ feature has been carried out and that the
																			specified system/ feature is now in a compliant state and fully
																			operational.
																		</td>
																	</tr>
																	<tr class="btm-border">
																		<td colspan="2">
																			<div contenteditable="true" class="editable-div">
																				An annual IQP inspection was
																				completed and the system(s) were found to be otherwise in a compliant
																				state and fully operational (see attached IQP statement).
																			</div>
																		</td>
																	</tr>
																	<tr>
																		<td colspan="2" style="font-style: italic; padding: 0 10px;">
																			3) A
																			statement that an Independent Qualified Person/Licensed Building
																			Practitioner has been and will continue to be engaged to inspect,
																			maintain and report on the specified feature /system.
																		</td>
																	</tr>
																	<tr class="btm-border">
																		<td colspan="2">
																			<div contenteditable="true" class="editable-div">
																				The owner will ensure an IQP is
																				contracted ongoing to inspect, maintain and report on the specified
																				system(s)/feature(s) in accordance with the compliance schedule. The IQP
																				is currently Compass New Zealand Ltd.
																			</div>
																		</td>
																	</tr>
																	<tr>
																		<td colspan="2" style="font-style: italic; padding: 0 10px;">
																			4) A
																			statement that the ongoing inspection, maintenance and reporting
																			procedures will be carried out to permit a 12A certificate to be issued
																			for that specified system(s)/feature(s) on the next and subsequent
																			anniversaries of the issued Compliance
																			Schedule.
																		</td>
																	</tr>
																	<tr class="btm-border">
																		<td colspan="2">
																			<div contenteditable="true" class="editable-div">
																				We are confident going forward
																				that inspection, maintenance and reporting procedures, in respect of the
																				specified system(s)/feature(s) detailed in this report, will be
																				complete as per the compliance schedule and a Form 12A provided in
																				conjunction with the next building warrant of fitness.
																			</div>
																		</td>
																	</tr>
																	<tr class="btm-border">
																		<td colspan="2">IQP statements are attached to support assertions in item 2 and 3 of this report. IQP statement by Compass New Zealand Ltd.</td>
																	</tr>
																	<tr>
																		<td style="font-style: italic; padding: 0 10px;" width="270px">Signed by building <span style="text-decoration: line-through;">owner</span> / owner's agent</td>
																		<td>
																			<div style="height: 50px; font-weight: bold; padding: 0 10px;">
																				<div class="document-text-border col mr-4 mt-1 css-image signature-keith" style="height:30px"></div>
																				Keith Flatt IQP #110459
																			</div>
																		</td>
																	</tr>
																	<tr>
																		<td style="font-style: italic; padding: 0 10px;" width="270px">Countersigned by</td>
																		<td>
																			<div style="height: 50px; font-weight: bold; padding: 0 10px;">
																				<div class="document-text-border col mr-4 mt-1" style="height:30px"></div>
																			</div>
																		</td>
																	</tr>
																	<tr>
																		<td style="padding: 0 10px;">Compass New Zealand Limited</td>
																		<td style="padding: 0 10px;"><strong>DATE:</strong> {{formattedDate(issuedDate || new Date())}}</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { PropertyData, CompanyData, ContactData, PropertyServiceData, PropertyBwofData } from '@/api-client/api-client'
	import { format, isValid } from 'date-fns';

	@Options({
		name: 'ReportInLieuOfForm12ATemplate',
		props: {
			propertyData: null,
			service: null,
			issuedDate: Date
		}
	})
	export default class ReportInLieuOfForm12ATemplate extends Vue {

		// Data
		propertyData: PropertyData = new PropertyData();
		ownerContact: ContactData = new ContactData;
		service: PropertyServiceData = new PropertyServiceData;
		owner: CompanyData = new CompanyData;
		bwof: PropertyBwofData = new PropertyBwofData;
		issuedDate: Date = new Date();

		created() {
			if (this.propertyData) {
				// Set Owner
				this.owner = this.propertyData.owner ? this.propertyData.owner : this.owner;

				// Set BWOF
				if (this.propertyData.propertyBwof)
					this.bwof = this.propertyData.propertyBwof;

				// Set Owner Contact from BWOF
				this.ownerContact = this.bwof.ownerContact != null ? this.bwof.ownerContact : this.ownerContact;
			}
		}

		formattedDate(date: Date) : string {
			if (!isValid(date)) return "";

			return format(date, 'd MMMM yyyy');
		}

		get visibleServices() {
			let services: PropertyServiceData[] = [];

			if (this.service.parentServiceId == null && this.propertyData.services) {

				services = this.propertyData.services.filter(s => s.parentServiceId == this.service.serviceId);
			} else {
				services.push(this.service);
			}

			return services;
		}
	}
</script>
<style scoped lang="scss">
	body, table td {
		font-size: 12px;
		line-height: 20px;
		font-family: arial, sans serif;
	}

	.title {
		text-align: center;
		font-size: 14px;
		text-transform: uppercase;
		font-weight: bold;
		border-bottom: 2px solid black;
	}

	.full-width {
		width: 750px;
	}

	.btm-border td {
		border-bottom: 1px solid gray;
		padding: 0 10px;
	}

	@media print {
		.full-width {
			width: 100%;
		}

		div#overall-body {
			width: 100%;
			background-color: white;
		}

		textarea {
			resize: none;
		}
	}

	textarea {
		width: 100%;
		padding: 0;
		border: none;
		margin: 5px 0;
		font-size: 12px;
	}

	.editable-div {
		padding: 0;
		border: none;
		margin: 5px 0;
		font-size: 12px;
		background-color: white;
		color: black;
		resize: vertical;
		overflow: auto;
	}
</style>